
export class TimeSeriesQueryResult {
    public count: number;
}
